import { createTheme } from '@material-ui/core/styles';
import palette from './palette';
import typography from './typography';
import overrides from './overrides';

const baseTheme = {
  palette,
  typography,
  overrides: {
    ...overrides,
    MuiTextField: {
      root: {
        '& label': {
          color: 'lightslategray', // Change label color for TextField
        },
        '& label.Mui-focused': {
          color: 'currentColor', // Change label color when focused for TextField
        },
        '& .MuiInputLabel-shrink': {
          color: 'currentColor', // Change label color when focused for TextField
        },        
      },
    },
    MuiAutocomplete: {
      root: {
        '& label': {
          color: 'lightslategray', // Change label color for Autocomplete
        },
        '& label.Mui-focused': {
          color: 'currentColor', // Change label color when focused for Autocomplete
        },
        '& .MuiInputLabel-shrink': {
          color: 'currentColor', // Change label color when focused for TextField
        }, 
      },
    },
  },
};

export const theme = createTheme(baseTheme);
export const themeWithRtl = createTheme({ ...baseTheme, direction: 'rtl' });
